import { t } from '@lingui/macro';
import { useApi } from '@prismo-io/core';
import type { SWRArgs } from '@prismo-io/schemas';
import toast from 'react-hot-toast';
import useSWRMutation from 'swr/mutation';
import { deleteExperience } from '../utils/delete-experience';
export function useDeleteExperience() {
  const {
    client
  } = useApi();
  return useSWRMutation('delete-quark-experience', (key, {
    arg
  }: SWRArgs<string>) => {
    return toast.promise(deleteExperience(client, arg), {
      loading: t`Suppression de l'expérience...`,
      success: t`L'expérience a bien été supprimée.`,
      error: t`Une erreur est survenue lors de la suppression de l'expérience.`
    });
  });
}